import { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

interface ProtectedRouteProps {
  children: ReactNode;
  allowedRoles?: Array<"admin" | "producer" | "buyer" | "staff">;
}

export function ProtectedRoute({ children, allowedRoles }: ProtectedRouteProps) {
  const { user, role, loading } = useAuth();
  const location = useLocation();


  // Auth loading is handled by parent Suspense - don't show extra spinner
  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-[50vh]">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/?login=true" state={{ from: location }} replace />;
  }

  if (allowedRoles) {
    if (!role) {
      // Role is null after loading finished — user has no valid role, block access
      return <Navigate to="/" replace />;
    }
    if (!allowedRoles.includes(role)) {
      const redirectMap: Record<string, string> = {
        admin: "/admin/relatorios",
        producer: "/produtor/dashboard",
        buyer: "/eventos",
        staff: "/staff",
      };
      return <Navigate to={redirectMap[role] || "/"} replace />;
    }
  }

  return <>{children}</>;
}
